import React, { Dispatch, SetStateAction, useContext, useState } from 'react';

import * as S from './styles';
import { useLocation, useNavigate } from 'react-router-dom';

import HomeIcon from '@mui/icons-material/Home';
import SchoolIcon from '@mui/icons-material/School';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import MonitorIcon from '@mui/icons-material/Monitor';

import { ButtonSimple } from '../../../../../Buttons';
import { ButtonStartIcon } from '../../../../../Buttons';
import { HiChatAlt2 } from 'react-icons/hi';
import { useUnreadMessagesCount } from '../../../../../../../hooks/useUnreadMessagesCount';
import ChatModal from '../../../../../../chat/ChatModal';
import {
  INewStudentProvider,
  NewStudentProviderContext,
} from '../../../../../ProviderNewStudent';
import { LibraryBooks } from '@mui/icons-material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
interface Props {
  setIsSidebarOpen?: Dispatch<SetStateAction<boolean>>;
}

export default function SideMenu({ setIsSidebarOpen }: Props) {
  const { student } = useContext(
    NewStudentProviderContext,
  ) as INewStudentProvider;
  const location = useLocation();
  const navigate = useNavigate();
  const [studentOpen, setStudentOpen] = useState<boolean>(false);
  const [financialOpen, setFinancialOpen] = useState<boolean>(false);
  const [courseOpen, setCourseOpen] = useState<boolean>(false);
  const [libraryOpen, setLibraryOpen] = useState<boolean>(
    location.pathname.includes('/acervo-virtual'),
  );
  const [chatOpen, setChatOpen] = useState(false);
  const unreadCount = useUnreadMessagesCount();
  return (
    <S.Container>
      <S.HeaderCollapse>
        <ButtonStartIcon
          color="primary"
          heightSize="medium"
          justify={'space-between'}
          startIcon={<HomeIcon fontSize="large" />}
          font="h6"
          onClick={() => {
            setIsSidebarOpen && setIsSidebarOpen(false);
            navigate('/new/aluno/inicio');
          }}
          boxShadow
        >
          INÍCIO
        </ButtonStartIcon>
      </S.HeaderCollapse>
      <S.HeaderCollapse>
        <ButtonStartIcon
          color="primary"
          heightSize="medium"
          endIcon={
            studentOpen ? (
              <RemoveCircleOutlineIcon fontSize="large" />
            ) : (
              <AddCircleOutlineIcon fontSize="large" />
            )
          }
          justify={'space-between'}
          startIcon={<SchoolIcon fontSize="large" />}
          font="h6"
          selected={studentOpen}
          onClick={() => {
            setFinancialOpen(false);
            setCourseOpen(false);
            setLibraryOpen(false);
            setStudentOpen(!studentOpen);
          }}
          boxShadow
        >
          ALUNO
        </ButtonStartIcon>
      </S.HeaderCollapse>
      {studentOpen && (
        <S.Collapse>
          <S.ChildCollapse>
            <ButtonSimple
              heightSize="medium"
              color="gray"
              selected={location.pathname.includes('/meus-dados')}
              onClick={() => {
                setIsSidebarOpen && setIsSidebarOpen(false);
                navigate('/new/aluno/meus-dados');
              }}
            >
              Meus Dados
            </ButtonSimple>
          </S.ChildCollapse>
          <S.ChildCollapse>
            <ButtonSimple
              heightSize="medium"
              color="gray"
              selected={location.pathname.includes('/documentos')}
              onClick={() => {
                setIsSidebarOpen && setIsSidebarOpen(false);
                navigate('/new/aluno/documentos');
              }}
            >
              Documentos
            </ButtonSimple>
          </S.ChildCollapse>
          <S.ChildCollapse>
            <ButtonSimple
              heightSize="medium"
              color="gray"
              selected={location.pathname.includes('/matricula')}
              onClick={() => {
                setIsSidebarOpen && setIsSidebarOpen(false);
                navigate('/new/aluno/matricula');
              }}
            >
              Contratos
            </ButtonSimple>
          </S.ChildCollapse>
          <S.ChildCollapse>
            <ButtonSimple
              heightSize="medium"
              color="gray"
              selected={location.pathname.includes('/declaracao')}
              onClick={() => {
                setIsSidebarOpen && setIsSidebarOpen(false);
                navigate('/new/aluno/declaracao');
              }}
            >
              Declarações
            </ButtonSimple>
          </S.ChildCollapse>
          <S.ChildCollapse>
            <ButtonSimple
              heightSize="medium"
              color="gray"
              selected={location.pathname.includes('/tickets')}
              onClick={() => {
                setIsSidebarOpen && setIsSidebarOpen(false);
                navigate('/new/aluno/tickets');
              }}
            >
              Requerimentos
            </ButtonSimple>
          </S.ChildCollapse>
        </S.Collapse>
      )}
      <S.HeaderCollapse>
        <ButtonStartIcon
          color="primary"
          heightSize="medium"
          endIcon={
            financialOpen ? (
              <RemoveCircleOutlineIcon fontSize="large" />
            ) : (
              <AddCircleOutlineIcon fontSize="large" />
            )
          }
          justify={'space-between'}
          startIcon={<AttachMoneyIcon fontSize="large" />}
          font="h6"
          selected={financialOpen}
          onClick={() => {
            setCourseOpen(false);
            setStudentOpen(false);
            setLibraryOpen(false);
            setFinancialOpen(!financialOpen);
          }}
          boxShadow
        >
          FINANCEIRO
        </ButtonStartIcon>
      </S.HeaderCollapse>
      {financialOpen && (
        <S.Collapse>
          <S.ChildCollapse>
            <ButtonSimple
              heightSize="medium"
              color="gray"
              selected={location.pathname.includes('/historico-financeiro')}
              onClick={() => {
                setIsSidebarOpen && setIsSidebarOpen(false);
                navigate('/new/aluno/historico-financeiro');
              }}
            >
              Histórico Financeiro
            </ButtonSimple>
          </S.ChildCollapse>
          <S.ChildCollapse>
            <ButtonSimple
              heightSize="medium"
              color="gray"
              selected={location.pathname.includes('/ir')}
              onClick={() => {
                setIsSidebarOpen && setIsSidebarOpen(false);
                navigate('/new/aluno/ir');
              }}
            >
              Informe - Imposto de Renda
            </ButtonSimple>
          </S.ChildCollapse>
        </S.Collapse>
      )}
      <S.HeaderCollapse>
        <ButtonStartIcon
          color="primary"
          heightSize="medium"
          endIcon={
            courseOpen ? (
              <RemoveCircleOutlineIcon fontSize="large" />
            ) : (
              <AddCircleOutlineIcon fontSize="large" />
            )
          }
          justify={'space-between'}
          startIcon={<MonitorIcon fontSize="large" />}
          font="h6"
          selected={courseOpen}
          onClick={() => {
            setFinancialOpen(false);
            setStudentOpen(false);
            setLibraryOpen(false);
            setCourseOpen(!courseOpen);
          }}
          boxShadow
        >
          CURSOS
        </ButtonStartIcon>
      </S.HeaderCollapse>
      {courseOpen && (
        <S.Collapse>
          <S.ChildCollapse>
            <ButtonSimple
              heightSize="medium"
              color="gray"
              selected={location.pathname.includes('/cursos')}
              onClick={() => {
                setIsSidebarOpen && setIsSidebarOpen(false);
                navigate('/new/aluno/cursos');
              }}
            >
              Meus Cursos
            </ButtonSimple>
          </S.ChildCollapse>
          <S.ChildCollapse>
            <ButtonSimple
              heightSize="medium"
              color="gray"
              selected={location.pathname.includes('/minhas-notas')}
              onClick={() => {
                setIsSidebarOpen && setIsSidebarOpen(false);
                navigate('/new/aluno/minhas-notas');
              }}
            >
              Minhas Notas
            </ButtonSimple>
          </S.ChildCollapse>
          <S.ChildCollapse>
            <ButtonSimple
              heightSize="medium"
              color="gray"
              selected={location.pathname.includes('/certificados')}
              onClick={() => {
                setIsSidebarOpen && setIsSidebarOpen(false);
                navigate('/new/aluno/certificados');
              }}
            >
              Certificados
            </ButtonSimple>
          </S.ChildCollapse>
        </S.Collapse>
      )}
      {student?.dataStudent?.hasGraduation && (
        <>
          <S.HeaderCollapse>
            <ButtonStartIcon
              color="primary"
              heightSize="medium"
              endIcon={
                libraryOpen ? (
                  <RemoveCircleOutlineIcon fontSize="large" />
                ) : (
                  <AddCircleOutlineIcon fontSize="large" />
                )
              }
              justify={'space-between'}
              startIcon={<LibraryBooks fontSize="large" />}
              font="h6"
              selected={libraryOpen}
              onClick={() => {
                setFinancialOpen(false);
                setStudentOpen(false);
                setCourseOpen(false);
                setLibraryOpen(!libraryOpen);
              }}
              boxShadow
            >
              BIBLIOTECA
            </ButtonStartIcon>
          </S.HeaderCollapse>
          {libraryOpen && (
            <S.Collapse>
              {student?.dataStudent?.cpf && (
                <S.ChildCollapse>
                  <ButtonSimple
                    heightSize="medium"
                    color="gray"
                    onClick={() => {
                      setIsSidebarOpen && setIsSidebarOpen(false);
                      window.open(
                        'https://hipatia.famart.com.br/api/8fgHD2fH84y/' +
                          student?.dataStudent?.cpf,
                        '_blank',
                      );
                    }}
                  >
                    Acervo Físico
                  </ButtonSimple>
                </S.ChildCollapse>
              )}
              <S.ChildCollapse>
                <ButtonSimple
                  heightSize="medium"
                  color="gray"
                  selected={location.pathname.includes('/acervo-virtual')}
                  onClick={() => {
                    setIsSidebarOpen && setIsSidebarOpen(false);
                    navigate('/new/aluno/acervo-virtual');
                  }}
                >
                  Acervo Virtual
                </ButtonSimple>
              </S.ChildCollapse>
            </S.Collapse>
          )}

          <S.HeaderCollapse>
            <ButtonStartIcon
              color="primary"
              heightSize="medium"
              justify={'space-between'}
              startIcon={<HiChatAlt2 fontSize="large" />}
              font="h6"
              onClick={() => {
                setChatOpen(true)
              }}
              boxShadow
            >
              TUTORIA
              {!chatOpen && unreadCount > 0 && (
                <S.NotificationBadge>
                  {unreadCount > 99 ? '99+' : unreadCount}
                </S.NotificationBadge>
              )}
            </ButtonStartIcon>
        </S.HeaderCollapse>
          <S.HeaderCollapse>
            <ButtonStartIcon
              color="primary"
              heightSize="medium"
              justify={'space-between'}
              startIcon={<CalendarMonthIcon fontSize="large" />}
              font="h6"
              selected={location.pathname.includes('/calendario')}
              onClick={() => {
                setIsSidebarOpen && setIsSidebarOpen(false);
                navigate('/new/aluno/calendario');
              }}
              boxShadow
            >
              CALENDÁRIO
            </ButtonStartIcon>
          </S.HeaderCollapse>
        </>
      )}

      <ChatModal isOpen={chatOpen} setIsOpen={setChatOpen} />
    </S.Container>
  );
}
